export default "__VITE_ASSET__BhKvWxFd__"